<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceReceivableAccounts",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'cap',
      breadcrumb: [
        { name: "财务管理", path: `/finance/receivableAccounts` },
        { name: "合同账款管理", path: `/finance/receivableAccounts` },
      ],
      formInline: {},
      formCtrl: [
        {
          // label: "合同编号：",
          keyName: "con_num",
          placeholder: "请填写合同编号",
          type: "text",
        },
      ],
      cols: [
        { prop: "con_num", label: "合同编号", minwidth: 120 },
        { prop: "shname", label: "客户名称" },
        { prop: "ston", label: "运送重量", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "cprice", label: "运费单价", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "yingshou", label: "应收账款", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "yingfu", label: "应付账款", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      btns: [
        {
          title: '统计',
          img: require('@/assets/img/icon_count.png'),
          unimg: require('@/assets/img/icon_count_hover.png'),
          cb: ({ id }) => {
            this.$router.push(
              `/finance/statistics?id=${id}`
            );
          },
        },
      ],
    };
  },
  methods: {},
};
</script>
